module.exports = __webpack_public_path__ + "static/img/logo_1.1dd4748.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_1.png
// module id = iWV5
// module chunks = 1